<pds-module-header title="Queries" ctaLabel="Voltar" ctaPath="/query" modifier="outlined">
  <pds-new-breadcrumb [items]="breadcrumb" />
  <pds-panel>
    <pds-form [formGroup]="formQuery.group">
      <pds-form-section title="Query">
        <pds-form-row>
          <pds-form-field label="Nome da query">
            <input type="text" formControlName="query" required [disabled]="isReadOnly" />
          </pds-form-field>
        </pds-form-row>
      </pds-form-section>

      <pds-form-section title="Grupo de Produtos">
        <pds-form-row grid="1">
          @if(updateForm || !isReadOnly) {
          <pds-form-field label="Pesquisar Grupo">
            <input type="text" formControlName="searchText" required [disabled]="loadingSearch" />
          </pds-form-field>
          } @if (updateForm || !isReadOnly) {
          <pds-form-field label="">
            <button pdsButton type="submit" (click)="searchProductGroup()">
              <span class="material-symbols-outlined"> search </span>
              Buscar @if(loadingSearch) {
              <div class="btn-spinner">
                <mat-spinner diameter="30" strokeWidth="2"></mat-spinner>
              </div>
              }
            </button>
          </pds-form-field>
          }
          <pds-form-field label="Grupo">
            <select (change)="onChangeSelectPG($event)" formControlName="productGroups" required [disabled]="disabledProductGroups()" aria-label="Selecione um grupo de produtos">
              @for (product of productGroups$ | async; track product.id) {
              <option [value]="product.id">
                {{ product.name }}
              </option>
              }
            </select>
          </pds-form-field>
        </pds-form-row>
      </pds-form-section>

      <pds-form-section title="Especificações">
        <pds-form-row>
          @if (formQuery.values.specifications.length <= 0 ) {
          <p>Nenhuma especificação</p>
          } @for (selectedSpecification of formQuery.controls.specifications.controls; track $index; let i = $index) {
          <div formArrayName="specifications" class="spec">
            <div class="row-specs" [formGroupName]="i">
              <pds-form-field class="type" label="Tipo">
                <select required (change)="onSelectType(i)" formControlName="specificationId">
                  @for (specification of specifications$.value[i]; track $index) {
                  <option [value]="specification.specificationId">
                    {{ specification.name }}
                  </option>
                  }
                </select>
              </pds-form-field>

              <pds-form-field class="value" label="Valor">
                <pds-select #pdsSelect formControlName="values" [options]="getOptionsForSpecification(i)" [disableSearch]="true"> </pds-select>
              </pds-form-field>

              <pds-form-field label="">
                <button [disabled]="formQuery.disabled" (click)="removeSpec(i)" class="buttonDel" pdsButton="icon">
                  <span class="material-symbols-outlined">remove</span>
                </button>
              </pds-form-field>
            </div>
          </div>
          }

          <pds-form-field label="">
            <button [disabled]="disabledAddSpec()" pdsButton color="primary" class="add" (click)="addSpec()">
              @if (!loadingSpec) {
              <div class="btn-content">
                <mat-icon>add</mat-icon>
                Adicionar Especificação
              </div>
              }@if (loadingSpec) {
              <div class="btn-spinner">
                <mat-spinner diameter="30" strokeWidth="2" color="accent"></mat-spinner>
              </div>
              }
            </button>
          </pds-form-field>
        </pds-form-row>
        <pds-form-row>
          <pds-checkbox label="Produto Universal" formControlName="universal" />
        </pds-form-row>
      </pds-form-section>

      <pds-form-section title="Quantidade">
        <pds-form-row grid="1">
          <pds-form-field label="Quantidade">
            <input type="number" formControlName="quantity" required />
          </pds-form-field>
        </pds-form-row>
      </pds-form-section>

      <pds-form-section title="Canais de vendas">
        <pds-form-row grid="1-1">
          @let whitelist = whitelist$ | async; @if (whitelist && whitelist.length > 0) {
          <pds-form-field label="Canais habilitados">
            <pds-select placeholder="Todos" [options]="whitelist" formControlName="whiteListControl"></pds-select>
          </pds-form-field>
          } @let blacklist = blacklist$ | async; @if(blacklist && blacklist.length > 0){
          <pds-form-field label="Canais desabilitados">
            <pds-select placeholder="Nenhum" [options]="blacklist" formControlName="blackListControl"></pds-select>
          </pds-form-field>

          }
        </pds-form-row>
      </pds-form-section>

      <div class="section">
        <pds-form-actions>
          @if (isReadOnly && updateForm) {
          <button pdsButton="primary" (click)="onClickCancel()">Cancelar</button>
          } @if (!isReadOnly || (isReadOnly && updateForm)) {
          <button pdsButton [disabled]="formQuery.group.invalid" (click)="save()">Salvar</button>
          }@else {
          <button pdsButton [disabled]="formQuery.group.invalid" (click)="onClickUpdate()" *allowTo="[['dialect-query-editar']]">Editar</button>
          }
        </pds-form-actions>
      </div>
    </pds-form>
  </pds-panel>
</pds-module-header>
